// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.12.4
//   protoc               unknown
// source: qonto/registration/organizations/firstparty/v1/get_organization.proto

/* oxlint-disable */
import { ApiOrganization } from "./organization";

/** Request message for retrieving an organization */
export interface ApiGetOrganizationRequest {
  /** The ID of the organization to retrieve */
  readonly id: string;
}

/** Response message for retrieving an organization */
export interface ApiGetOrganizationResponse {
  /** The requested organization */
  readonly organization: ApiOrganization | null;
}

/** Error codes for GetOrganization operation */
export interface ApiGetOrganizationErrors {
}

/** Not found error codes */
export const ApiGetOrganizationErrorsNotFoundError = {
  /** NOT_FOUND_ERROR_UNSPECIFIED - Unspecified not found error */
  NOT_FOUND_ERROR_UNSPECIFIED: "NOT_FOUND_ERROR_UNSPECIFIED",
  /** NOT_FOUND_ERROR_NOT_FOUND_OR_UNAUTHORIZED - Organization not found or unauthorized */
  NOT_FOUND_ERROR_NOT_FOUND_OR_UNAUTHORIZED: "NOT_FOUND_ERROR_NOT_FOUND_OR_UNAUTHORIZED",
} as const;

export type ApiGetOrganizationErrorsNotFoundError =
  typeof ApiGetOrganizationErrorsNotFoundError[keyof typeof ApiGetOrganizationErrorsNotFoundError];

export namespace ApiGetOrganizationErrorsNotFoundError {
  export type NOT_FOUND_ERROR_UNSPECIFIED = typeof ApiGetOrganizationErrorsNotFoundError.NOT_FOUND_ERROR_UNSPECIFIED;
  export type NOT_FOUND_ERROR_NOT_FOUND_OR_UNAUTHORIZED =
    typeof ApiGetOrganizationErrorsNotFoundError.NOT_FOUND_ERROR_NOT_FOUND_OR_UNAUTHORIZED;
}

export function apiGetOrganizationErrorsNotFoundErrorFromJSON(object: any): ApiGetOrganizationErrorsNotFoundError {
  switch (object) {
    case 0:
    case "NOT_FOUND_ERROR_UNSPECIFIED":
      return ApiGetOrganizationErrorsNotFoundError.NOT_FOUND_ERROR_UNSPECIFIED;
    case 1:
    case "NOT_FOUND_ERROR_NOT_FOUND_OR_UNAUTHORIZED":
      return ApiGetOrganizationErrorsNotFoundError.NOT_FOUND_ERROR_NOT_FOUND_OR_UNAUTHORIZED;
    default:
      return ApiGetOrganizationErrorsNotFoundError.NOT_FOUND_ERROR_UNSPECIFIED;
  }
}

export function apiGetOrganizationErrorsNotFoundErrorToJSON(object: ApiGetOrganizationErrorsNotFoundError): string {
  switch (object) {
    case ApiGetOrganizationErrorsNotFoundError.NOT_FOUND_ERROR_UNSPECIFIED:
      return "NOT_FOUND_ERROR_UNSPECIFIED";
    case ApiGetOrganizationErrorsNotFoundError.NOT_FOUND_ERROR_NOT_FOUND_OR_UNAUTHORIZED:
      return "NOT_FOUND_ERROR_NOT_FOUND_OR_UNAUTHORIZED";
    default:
      return "NOT_FOUND_ERROR_UNSPECIFIED";
  }
}

export const ApiGetOrganizationRequest: MessageFns<ApiGetOrganizationRequest> = {
  fromJSON(object: any): ApiGetOrganizationRequest {
    return { id: isSet(object.id) ? globalThis.String(object.id) : "" };
  },

  toJSON(message: ApiGetOrganizationRequest): unknown {
    const obj: any = {};
    if (message.id !== undefined && message.id !== null) {
      obj.id = message.id;
    }
    return obj;
  },
};

export const ApiGetOrganizationResponse: MessageFns<ApiGetOrganizationResponse> = {
  fromJSON(object: any): ApiGetOrganizationResponse {
    return { organization: isSet(object.organization) ? ApiOrganization.fromJSON(object.organization) : null };
  },

  toJSON(message: ApiGetOrganizationResponse): unknown {
    const obj: any = {};
    if (message.organization !== undefined && message.organization !== null) {
      obj.organization = ApiOrganization.toJSON(message.organization);
    }
    return obj;
  },
};

export const ApiGetOrganizationErrors: MessageFns<ApiGetOrganizationErrors> = {
  fromJSON(_: any): ApiGetOrganizationErrors {
    return {};
  },

  toJSON(_: ApiGetOrganizationErrors): unknown {
    const obj: any = {};
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
